import { Storage } from '@/shared/domain/enums/Storage';

export const getStorageSession = () =>
  localStorage.getItem(Storage.CreditasAffiliatesToken);

export const deleteStorageSession = () =>
  localStorage.removeItem(Storage.CreditasAffiliatesToken);

export const deleteStorageExpiresSession = () =>
  localStorage.removeItem(Storage.CreditasAffiliatesTokenExpires);

export const getStorageExpiresSession = () =>
  localStorage.getItem(Storage.CreditasAffiliatesTokenExpires);

export const getStorageUserTraits = () =>
  localStorage.getItem(Storage.CreditasAjsUserTraits);
